import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '@narvar/nth-button';

export const mapStateToProps = ({
  page: { productType } = {},
  language: { 'returns.general.back_button': backText } = {},
  returnsSettings: { [productType]: { enableBackButton = false } = {} } = {},
}) => ({
  backText,
  visible: enableBackButton,
});

const BackButton = ({ backText, visible, onClick }) => {
  if (!visible) return null;
  return (
    <Button big className="narvar-btn-tertiary" s={{ fontSize: '14px' }} onClick={onClick}>
      {backText}
    </Button>
  );
};

BackButton.defaultProps = {
  backText: 'Back',
};

BackButton.propTypes = {
  visible: PropTypes.bool.isRequired,
  backText: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(BackButton);
export { BackButton };
